import React from "react";
import { MediaItem } from "@/core/MediaItem/MediaItem.model";
import { MediaStage } from "@/core/types/mediaTypes";
import { PostSelectorMediaCard } from "@/components/MediaCard";
import { useAppStore } from "@/core/store/useAppStore";

interface MediaItemsGridProps {
  images: MediaItem[];
  selectedMediaItems: MediaItem[];
  onImageClick: (image: MediaItem) => void;
  isLoading: boolean;
  error: string | null;
  isCarousel: boolean;
}

export const MediaItemsGrid: React.FC<MediaItemsGridProps> = ({
  images,
  selectedMediaItems,
  onImageClick,
  isLoading,
  error,
  isCarousel,
}) => {
  const { selectedClient } = useAppStore();

  if (!selectedClient && isLoading && images.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading images...</p>
        </div>
      </div>
    );
  }

  if (error && images.length === 0) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center text-red-600">
          <p className="mb-2">Failed to load images</p>
          <p className="text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-3 sm:gap-4">
      {/* Images */}
      {images.map((image) => {
        const isSelected = selectedMediaItems.some(
          (img) => img.id === image.id,
        );
        const selectionIndex = selectedMediaItems.findIndex(
          (img) => img.id === image.id,
        );

        return (
          <PostSelectorMediaCard
            key={image.id}
            mediaItem={image}
            clientId={selectedClient?.id!}
            isSelected={isSelected}
            selectionIndex={selectionIndex}
            showNumbering={isCarousel}
            onClick={() => onImageClick(image)}
            onStageChange={(updatedImage, oldStage: MediaStage) => {
              console.log("Image stage changed in post creator:", updatedImage, "from", oldStage);
            }}
            onActionError={(error) => {
              console.error("Image action error in post creator:", error);
            }}
          />
        );
      })}
    </div>
  );
};
